import React from 'react';
import { useTheme } from '../ThemeContext';

const ThemeToggle = () => {
  const { isInstitutional, toggleTheme } = useTheme();

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      title={isInstitutional ? 'Passa al tema Dark' : 'Passa al tema Chiaro'}
      className="flex items-center transition-all duration-300 cursor-pointer group"
    >
      {isInstitutional ? (
        /* In modalita chiara: cerchio nero con centro verde Matrix */
        <span
          className="inline-flex items-center justify-center w-8 h-8 rounded-full transition-all duration-300 group-hover:scale-110"
          style={{
            background: '#000',
            border: '2px solid #00FF41',
            boxShadow: '0 0 10px rgba(0,255,65,0.4)',
          }}
        >
          <span style={{ fontSize: '10px', fontWeight: 900, color: '#00FF41', fontFamily: "'Source Serif 4', serif" }}>&lt;/</span>
        </span>
      ) : (
        /* In modalita dark: cerchio arancione con bordo bianco */
        <span
          className="inline-flex items-center justify-center w-8 h-8 rounded-full transition-all duration-300 group-hover:scale-110"
          style={{
            background: '#C4532D',
            border: '2px solid #fff',
            boxShadow: '0 0 10px rgba(196,83,45,0.4)',
          }}
        >
          <span style={{ fontSize: '10px', fontWeight: 900, color: '#fff', fontFamily: "'Source Serif 4', serif" }}>&lt;/</span>
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
